<template>
  <div class="wrap">
    <article class="c-product-tile">
      <div class="c-product-tile__remove">
        <button class="c-button c-button--rounded" type="button" @click="onRemove">
          <i class="iconfont">&#xe615;</i>
        </button>
      </div>
      <div class="cart-top">
        <div class="cart-left">
          <!-- 图片 -->
          <div class="c-product-tile__image-container">
            <img class="product-image lazyloaded" :src="base.pc_pic || base.pic" :alt="base.name" />
          </div>
        </div>
        <div class="cart-info">
          <!-- 名称 & 描述 -->
          <div class="line-item-header">
            <router-link :to="`/detail?id=${base.id}`">
              <h2 class="c-product-tile__name">{{base.name}}</h2>
            </router-link>
            <!-- <p class="c-product-tile__description text--no-margin">{{base.short_desc}}</p> -->
          </div>
          <!-- 促销信息 -->
          <!-- <div class="c-product__promotion" v-if="Array.isArray(base.promotion_msg) && base.promotion_msg.length">{{base.promotion_msg | promotionStrify }}</div> -->
          <!-- 常规商品的规格选择 -->
          <div class="item-attributes">
            <div v-if="/(capacity|color)/i.test(base.display_type)" class="text--no-margin line-item-attributes">
              {{ base.display_type | classify }}：
              <span v-if="base.display_type == 'color'" class="c-product-tile__selected-color-circle" :style="{background: `#${base.spec_property}`}"></span>
              <span class="c-product-tile__selected-color-name">{{base.spec_desc}}</span>
              <!-- SKU数量大于1个时才有选择SKU功能 -->
              <!-- <template v-if="base.origin_product_data && base.origin_product_data.skus && base.origin_product_data.skus.length > 1 || false">
                <i class="iconfont editable-sku" @click="toggleSKUOptions(0)">&#xe684;</i>
              </template> -->
            </div>
          </div>
          <!-- 价格 -->
          <div class="c-product-tile__price">
            <!-- <div class="origin" v-if="base.original_price && base.original_price != base.price">￥{{base.original_price}}</div> -->
            <div class="now c-button--bold" v-if="base.original_price && base.original_price != base.price">￥{{base.original_price}}</div>
            <div class="now c-button--bold" v-else>￥{{base.price}}</div>
            <div style="float:right">x{{base.qty}}</div>
          </div>
          <!-- <div class="m-cart__warning" v-if="base.stock <= 0">已售罄</div> -->
          <!-- <div class="m-cart__warning" v-else-if="parseInt(base.stock) < parseInt(base.qty)">库存仅剩{{base.stock}}件</div> -->
          <div class="m-cart__label heading-h6 collection__label" v-if="/collection/i.test(base.display_type)" @click="toggleCollectionsView">
            套装详情<i :class="['iconfont', isCollapsed ? '' : 'expand']">&#xe678;</i>
          </div>
        </div>
      </div>
      <!-- 套装详情 -->
      <div :class="['suit-detail', isCollapsed ? 'collapsed' : '']" v-if="/collection/i.test(base.display_type)">
        <article class="c-product-detail" v-for="(suitItem, suitIndex) in base.collections" :key="suitIndex">
          <!-- 占位 -->
          <div class="cart-left">
            <!-- 选择框 -->
            <div class="float-left select-singel" @click="toggleSelected">
              <i class="iconfont select-all">{{selected ? '&#xe640;' : '&#xe60f;'}}</i>
            </div>
            <!-- 图片 -->
            <div class="c-product-tile__image-container">
              <img class="product-image lazyloaded" :src="base.pc_pic || base.pic" :alt="base.name" />
            </div>
          </div>
          <!-- 套装信息 -->
          <div class="detail-li">
            <div class="c-product-tile__image-container">
              <img class="product-detail-image lazyloaded" :src="suitItem.pc_pic || suitItem.pic" :alt="suitItem.name" />
            </div>
            <div class="c-product-tile__body flex-column">
              <div class="line-item-header">
                <h2 class="c-product-tile__name">{{suitItem.name}}</h2>
                <!-- <p class="c-product-tile__description text--no-margin">{{suitItem.short_desc}}</p> -->
              </div>
              <div class="item-attributes">
                <div v-if="/(capacity|color)/i.test(suitItem.display_type)" class="text--no-margin line-item-attributes">
                  {{suitItem.display_type | classify}}：
                  <span v-if="suitItem.display_type=='color'" class="c-product-tile__selected-color-circle" :style="{background: `#${suitItem.spec_property}`}"></span>
                  <span class="c-product-tile__selected-color-name">{{suitItem.spec_desc}}</span>
                  <!-- 套装中商品SKU数量大于1才显示 -->
                  <!-- <template v-if="base.display_type == 'collection' && suitItem.origin_spu && suitItem.origin_spu.skus.length > 1">
                    <i class="iconfont editable-sku" @click="toggleSKUOptions(suitIndex)">&#xe684;</i>
                  </template> -->
                </div>
                <div class="modal" v-if="showSKUOptions[suitIndex] || false">
                  <div :class="['select-list', `${suitItem.display_type}__list`]">
                    <div class="select-title">修改产品{{ suitItem.display_type == 'color' ? '色号' : '规格' }}</div>
                    <div class="c-button c-button--rounded close-icon" @click="toggleSKUOptions(suitIndex)">
                      <i class="iconfont">&#xe615;</i>
                    </div>
                    <div class="item-skus__list">
                      <VueScroll :ops="vsOpts">
                        <ul>
                          <li
                            :class="[suitItem.display_type=='color'?'color-li':'capacity-li', skuItem.sku_id == suitItem.sku ? 'selected' : '']"
                            v-for="(skuItem,skuIndex) in suitItem.origin_spu.skus" :key="skuIndex"
                            @click="setFakeSKUIndex(suitIndex, skuIndex)"
                          >
                            <div class>
                            <div v-if="suitItem.display_type=='color'" :class="['m-product-details__swatch', skuItem.sku_id == suitItem.sku ? 'selected' : '']">
                              <span class="m-product-details__swatch-circle" :style="{background: `#${skuItem.spec_property}`}"></span>
                            </div>
                            <span>{{ skuItem.spec_desc}}</span>
                            </div>
                            <i class="iconfont">{{ (fakeSKUIndex[suitIndex] == skuIndex || (fakeSKUIndex[suitIndex] == -1 && realSKUIndex[suitIndex] == skuIndex)) ? '&#xe640;' : '&#xe60f;' }}</i>
                          </li>
                        </ul>
                      </VueScroll>
                    </div>
                    <button class="c-button c-button--primary hide-for-sm" @click="setRealSKUIndex(suitIndex)">确定</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </article>
  </div>
</template>

<script>
import 'vuescroll/dist/vuescroll.css';
import VueScroll from 'vuescroll/dist/vuescroll-native';
import utils from "@/utils";

export default {
  name: "CartItem",
  components: { VueScroll },
  props: {
    // 商品信息
    base: {
      type: Object,
      required: true
    },
    // 赠品信息
    gifts: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      vsOpts: {
        bar: {
          background: '#F6F6F6'
        }
      },
      // 
      selected: false, // 条目选中状态
      // 选购数量控制
      showQuantity: false,   // 数量选择弹层显示状态
      fakeNumIndex: -1,      // 数量选中项的下标
      realNumIndex: -1,      // 数量选中项的下标
      // 选购SKU控制
      showSKUOptions: [false], // SKU选择弹层显示状态
      fakeSKUIndex: [-1],      // SKU选中项的下标
      realSKUIndex: [-1],      // SKU选中项的下标
      // 
      isCollapsed: true
    };
  },
  created() {
    this.init();
    this.initEvent();
  },
  methods: {
    merge(items, field) {
      if (Array.isArray(items) && items.length && field) {
        if(items[0].qty>0){ //兼容新版API
          return items;
        }
        let retMap = {}, fieldMap = {};
        items.forEach(item => {
          if (item[field]) {
            if (fieldMap[item[field]]) {
              retMap[item[field]].qty += 1;
            } else {
              fieldMap[item[field]] = 1;
              retMap[item[field]] = { ...item, qty: 1 };
            }
          }
        });
        return Object.values(retMap);
      }
      return items;
    },
    // 重置数量&SKU弹窗控制参数
    resetPopup() {
      let size = 0;
      if (this.base.display_type == "collection") {
        size = this.base.collections.length;
      } else {
        size = 1;
      }
      this.showQuantity = false;
      this.fakeNumIndex = -1;
      this.showSKUOptions.length = size;
      this.fakeSKUIndex.length = size;
      for (let i = 0; i < size; i++) {
        this.$set(this.showSKUOptions, i, false);
        this.$set(this.fakeSKUIndex, i, -1);
      }
    },
    // 初始化：预购数量的下标 & 预购SKU的下标
    init() {
      // 重置
      this.resetPopup();
      // 记录预购数量的下标
      let maxStock = Math.min(this.base.stock, 6);
      if (this.base.qty <= maxStock) {
        this.realNumIndex = this.base.qty - 1;
      } else {
        console.info("[Warning]: 预购数量超过库存数量");
      }
      // 记录预购SKU的下标
      if (this.base.display_type == "collection") {
        this.base?.collections.forEach((suitItem, suitIndex) => {
          suitItem?.origin_spu.skus.forEach((skuItem, skuIndex) => {
            if (suitItem.sku == skuItem.sku_id) {
              this.$set(this.realSKUIndex, suitIndex, skuIndex);
            }
          });
        });
      } else if (this.base?.origin_product_data?.skus?.length > 1) {
        let idx = this.base.origin_product_data.skus.findIndex(
          sku => sku.sku_id == this.base.sku
        );
        idx != -1 && (this.$set(this.realSKUIndex, 0, idx));
      } else {
        this.$set(this.realSKUIndex, 0, 0);
      }
      this.selected = this.base.selected;
    },
    // 外部点击事件处理
    initEvent() {
      document.addEventListener("click", this.closePopup, false);
      this.$once("hook:beforeDestroy", () => {
        document.removeEventListener("click", this.closePopup, false);
      });
    },
    // 关闭弹窗
    closePopup(evt) {
      let dom = evt.target || evt.srcElement;
      //
      if (
        dom.classList.contains("c-select") ||
        utils.closest(dom, ".c-select") ||
        dom.classList.contains("editable-sku") ||
        utils.closest(dom, ".select-list-li") ||
        utils.closest(dom, ".select-li") ||
        utils.closest(dom, ".select-list")
      ) {
        return false;
      } else {
        this.resetPopup();
      }
    },
    // 切换购物车条目选中状态
    toggleSelected() {
      this.selected = !this.selected;
      this.$emit("selected", {
        item: this.base,
        state: this.selected
      });
    },
    // 删除购物车记录条目
    onRemove() {
      this.$emit("remove", { item: this.base });
    },
    // 切换显示预购数量选择弹层
    toggleQuantity() {
      this.showQuantity = !this.showQuantity;
    },
    // 修改预购数量下标
    setFakeNumIndex(index) {
      let errMsg = "";
      if (this.base.stock <= 0) {
        errMsg = "已售罄";
      } else if (this.base.stock < index +1) {
        errMsg = `库存仅剩${this.base.stock}件`;
      }
      if (errMsg) {
        this.$toast({ message: errMsg, iconCls: "failure" });
        this.toggleQuantity();
        return false;
      }
      if (utils.isMobile() || utils.isWXBrowser()) {
        this.fakeNumIndex = index;
      } else {
        this.realNumIndex = index;
        this.fakeNumIndex = -1;  
        this.$emit("changenum", {
          item: this.base,
          index,
          count: index + 1
        });
        this.toggleQuantity();
      }
    },
    // 确定预购数量下标
    setRealNumIndex() {
      this.realNumIndex = this.fakeNumIndex;
      this.fakeNumIndex = -1;
      this.$emit("changenum", {
        item: this.base,
        index: this.realNumIndex,
        count: this.realNumIndex + 1
      });
      this.toggleQuantity();
    },
    // 切换显示SKU选择弹层
    toggleSKUOptions(index = 0) {
      this.showSKUOptions.forEach((skuOptionItem, skuOptionIndex) => {
        this.$set(this.showSKUOptions, skuOptionIndex, skuOptionIndex == index ? !this.showSKUOptions[index] : false);
      });
    },
    // 修改预购的SKU下标
    setFakeSKUIndex(suitIndex = 0, index) {
      if (utils.isMobile() || utils.isWXBrowser()) {
        this.$set(this.fakeSKUIndex, suitIndex, index);
      } else {
        this.$set(this.fakeSKUIndex, suitIndex, index);
        this.setRealSKUIndex(suitIndex);
      }
    },
    // 确定预购的SKU下标
    setRealSKUIndex(suitIndex) {
      let skuIndex = this.fakeSKUIndex[suitIndex];
      this.$set(this.realSKUIndex, suitIndex, skuIndex);
      this.$set(this.fakeSKUIndex, suitIndex, -1);
      this.toggleSKUOptions(suitIndex);
      // 事件派发
      let currentSKUItems = [];
      if (this.base.display_type == "collection") {
        currentSKUItems = this.base?.collections?.map((item, index) => item?.origin_spu?.skus?.find((skuItem, skuIndex) => skuIndex == this.realSKUIndex[index]));
      } else if (this.base.display_type == "collection_sku") {
        currentSKUItems = [this.base?.origin_product_data?.skus?.[0]];
      } else { // "capacity_ml", "capacity_g", "color"
        currentSKUItems = [this.base?.origin_product_data?.skus?.[this.realSKUIndex[0]]];
      }
      this.$emit("changesku", {
        item: this.base,
        index: this.realSKUIndex,
        skus: currentSKUItems
      });
    },
    toggleCollectionsView() {
      this.isCollapsed = !this.isCollapsed;
    }
  },
  computed: {
    stockItems() {
      let maxStock = Math.min(this.base.stock, 6);
      return [1, 2, 3, 4, 5, 6].splice(0, maxStock);
    }
  },
  watch: {
    "base"() {
      this.init();
    },
    // eslint-disable-next-line no-unused-vars
    "base.selected"(newVal, oldVal) {
      this.selected = newVal;
    }
  },
  filters: {
    promotionStrify(msgs) {
      return msgs.map(item => item.name).join(";")
    },
    promotionTypeFilter(items, filter) {
      return items.filter(item => item.type == filter)?.[0]?.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-button--rounded{
  width: 24px;
  height: 24px;
  .iconfont{
    font-size: 12px;
  }
}
.c-product-tile {
  position: relative;
  padding-top: 30px;
  .cart-left { display: flex; justify-content: flex-start; align-items: center; }
  ul { margin-bottom: 0; padding: 1.25rem 0; }
  .item-skus__list {
    height: 240px; margin-bottom: 1.25rem; overflow: auto;
    ul { padding-bottom: 0; }
  }
  .c-product-tile__remove { position: absolute; right: 0; top: 25px; }
  .select-singel {
    .iconfont { cursor: pointer; color: #333; }
  }
  .cart-top { display: flex; align-self: flex-start; }
  .suit-detail {
    .cart-left{ display: none; }
    .c-product-detail {
      display: flex; margin-top: 0.625rem;
      &:first-child { margin-top: 0; }
    }
    &.collapsed { height: 0; overflow: hidden; }
  }
  .detail-li{ display: flex; margin: 0.625rem 0 0 1.25rem; flex: 1; }
  .suit-detail .product-detail-image{ width: 50px; }
  .cart-bottom, .c-product-tile__body {
    display: flex;
    .cart-left { opacity: 0; }
  }
  .c-product-tile__body { flex: 1; }
  .flex-column { flex-direction: column; }
  .c-product-tile__image-container {
    margin: 0 20px;
    margin-left: 0;
    img { max-width: 106px; height: auto; }
  }
  .cart-info {
    flex: 1;
  }
  .cart-info > .line-item-header a {
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
  .c-product-tile__name { font-size: 12px; font-weight: 500; width: 87%;}
  .c-product-tile__selected-color-circle { border-radius: 50%; display: inline-block; height: 0.625rem; width: 0.625rem; margin-right: 0.6875rem; }
  .item-attributes { margin-top: 0.5rem; }
  .line-item-attributes .iconfont { font-size: 12px; margin-left: 10px; cursor: pointer; }
  .c-product-tile__price {
    display: flex; margin-top: 0.5rem;
    justify-content: space-between;
    .origin { text-decoration: line-through; color: #575757; margin-right: 0.625rem; }
    .now { color: #000; font-weight: 700; }
  }
  .c-product__promotion { color: #D71212; font-size: 12px; line-height: 12px; margin-top: 0.5rem; }
  .m-cart__warning { color: #D71212; font-size: 12px; }
  .m-product-details__swatch {
    display: flex; float: left; padding: 0.15rem; margin-right: 1rem; cursor: pointer;
    background: #fff; border-radius: 50%; border: 0.0625rem solid transparent;
    &.selected, &:hover { border-color: #cacaca; }
  }
  .m-product-details__swatch-circle { border-radius: 50%; display: block; height: 0.9375rem; position: relative; width: 0.9375rem; }
  .m-cart__label { flex-shrink: 0; }
  .collection__label {
    display: flex; justify-content: flex-start; align-items: center; line-height: 1; margin-top: 12px; cursor: pointer;
    .iconfont {
      margin-left: 0.625rem; transition: transform 0.2s linear;
      &.expand { transform: rotate(180deg); }
    }
  }
  .c-select {
    height: 2.75rem;
    padding: 0 0.625rem 0 1.25rem;
    margin-bottom: 0.625rem;
    cursor: pointer;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(213, 213, 213, 1);
    border-radius: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    margin-left: 10px;
    width: 100%;
  }
  .m-cart__quantity { display: flex; flex-direction: row; align-items: center; padding: 0; margin-top: 1.25rem; }
  .c-product-tile__row { width: 100%; margin-bottom: 3.125rem; position: relative; }
  .c-product-gift {
    padding-bottom: 3.125rem; flex: 1;
    // border-top: 1px solid #cfd0d1;
    .gift-tile { margin-bottom: 1.75rem; }
    .gift-list {
      display: flex; flex-wrap: wrap;
      .gift-contanier {
        display: flex; align-items: center; margin: 1.75rem 0 0;
        &:first-child { margin-top: 0; }
        img { width: 62px; height: 82px; }
        .gift-info {
          margin-left: 0.75rem; display: flex; flex-direction: column;
          .gift-name { font-size: 14px; color: #000; }
          .gift-quantity { font-size: 12px; line-height: 1; margin-top: 10px; }
        }
      }
    }
  }
  .select-list-li {
    position: absolute;
    z-index: 1;
    background: #fff;
    box-shadow: 0 0 0.625rem 0 #ccc;
    padding: 1.875rem;
    min-width: 10.6875rem;
    overflow: auto;
    width: 100%;
    bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    button.hide-for-sm { display: block; width: 100%; }
  }
  .modal { position: fixed; top: 0; left: 0; min-width: 100%; height: 100%; z-index: 99; background-color: rgba(0, 0, 0, 0.5); }
  .select-list {
    position: absolute;
    bottom: 0;
    z-index: 1;
    background: #fff;
    box-shadow: 0 0 0.625rem 0 #ccc;
    margin-top: 0.3125rem;
    padding: 1.875rem;
    min-width: 10.6875rem;
    width: 100%;
    overflow: auto;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .select-li, .capacity-li, .color-li { cursor: pointer; }
    button.hide-for-sm { display: block; width: 100%; }
    &.color__list {
      padding: 1.875rem 1.25rem 1.875rem 1.875rem;
      .item-skus__list ul { padding-right: 0.625rem; }
    }
  }
  .select-li {
    display: block; padding: 0.625rem; border-radius: 0.5rem; cursor: pointer;
    &.selected { background-color: #f5f5f5; }
  }
  .select-title { display: block; font-size: 1.125rem; }
  .color-li {
    padding: 0.625rem 0; display: flex; justify-content: space-between; align-items: center;
    &:first-child { padding-top: 0; }
    &:last-child { padding-bottom: 0; }
    .iconfont { color: #000; }
  }
  .capacity-li {
    display: flex; justify-content: space-between; align-items: center; padding: 0.625rem 0; border-bottom: 1px solid #dcdcdc;
    .iconfont { color: #000; }
  }
  .close-icon { width: 1.5rem; height: 1.5rem; line-height: 1.4rem; text-align: center; display: block; position: absolute; right: 1.25rem; top: 1.25rem; }
}
@media only screen and (min-width: 48rem) {
  .c-product-tile {
    ul {
      padding: 0;
    }
    .item-skus__list {
      margin-bottom: 0;
    }
    // .select-singel { margin-right: 1.75rem; }
    .item-attributes {
      position: relative;
    }
    .c-select { margin-left: 0; }
    .suit-detail{
      .cart-left{
        opacity: 0;
        display: block;
      }
    }
    .select-list-li {
      top: 5rem;
      bottom: unset;
      border-radius: 0;
    }
    .detail-li{
      margin-left: 0;
    }
    .modal {
      position: static;
      top: 0;
      left: 0;
      min-width: 100%;
      height: 100%;
      background-color: transparent;
    }
    .select-list {
      min-width: 14.6875rem;
      width: unset;
      border-radius: 0;
      top: 1rem;
      bottom: unset;
      &.color__list { padding: 1.875rem; }
    }
    .select-title {
      display: none;
    }
    .color-li {
      .iconfont {
        display: none;
      }
    }
    .m-cart__quantity {
      position: relative;
      flex-direction: column;
      align-items: flex-start;
    }
    .capacity-li {
      display: inline-block;
      padding: 0;
      margin-right: 0.625rem;
      border-bottom: 0;
      .iconfont {
        display: none;
      }
      &.selected {
        border-bottom: 1px solid #000;
      }
    }
    .select-li {
      display: block;
      padding: 0.625rem;
      border-radius: 0.5rem;
      &.selected {
        background-color: #f5f5f5;
      }
    }
    .close-icon {
      display: none;
    }
  }
}
@media screen and (min-width: 64rem) {
  .c-product-tile {
    .c-product-tile__image-container {
      // min-height: 7.5rem; width: 11.6875rem; max-width: 31.5%; margin: 0 20px;
      img {
        width: 60px;
        height: auto;
        max-height: 140px;
      }
    }
    .c-product-gift {
      .gift-list {
        .gift-contanier {
          &:nth-child(-n+3) { margin-top: 0; }
        }
      }
    }
  }
}
</style>